// 引入api
import { fun_GetAction, fun_PostAction, fun_PutAction } from "@/api";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      type: "add",
      // 抽屉状态
      drawerStatus: false,
      // 抽屉确定按钮loading状态
      loading: false,
      options: [], // 部门下拉框值
      mineStatusValue: "",
      // 查询表单字段
      form: {
        id: null, // id
        departmentName: null, // 部门名称
        departmentCode: null, // 部门编号
        parentId: null // 上级菜单
      },
      // 详情表单基础数据
      formConfigList: [
        {
          label: "部门名称：",
          value: "departmentName",
          type: "input",
          required: true,
          maxlength: 150,
          rule: {
            required: true,
            message: "请输入部门名称",
            trigger: "blur"
          }
        },
        {
          label: "部门编号：",
          value: "departmentCode",
          type: "input",
          required: true,
          maxlength: 50,
          rule: {
            required: true,
            message: "请输入部门编号",
            trigger: "blur"
          }
        },
        {
          label: "所属部门：",
          type: "slot",
          slotName: "pid",
          required: false,
          rule: {
            required: false,
            message: "请选择上级菜单",
            trigger: "change"
          }
        }
      ],
      // 后台返回错误对象
      errRules: {},
      // tree数据默认参数和后台给的参数对应
      defaultProps: {
        children: "children", // 子节点名称
        label: "departmentName" // 节点名称
      },
      parentName: null // 回显高亮部门
    };
  },
  // 自定义方法
  methods: {
    /**
     * 获取详情
     * @author 滕威
     */
    async fun_GetDetails(e) {
      this.type = "edit";
      // 获取部门主键
      this.form.id = e.id;
      // 获取所有部门的下拉框
      this.fun_DepartmentSelect();
      // 请求，获取结果集
      let res = await fun_GetAction("/department/detail?id=" + this.form.id);
      // 解构res.data
      const { result, data, msg } = res.data;
      // 判断请求是否成功
      if (result) {
        // 回显表单
        for (let key in this.form) {
          this.form[key] = data[key];
        }
        // 所属部门高亮显示
        this.$refs.tree.setCurrentKey(this.form.parentId);
        console.log(data);
        // 如果不是一级节点下拉是输入框里面显示名称
        if (data.parentId != "0") {
          this.parentName = data.parentName;
        }
      } else {
        // 请求失败，提示错误信息
        this.$message.error(msg);
      }
    },
    /**
     * 获取部门所有下拉框
     */
    async fun_DepartmentSelect() {
      // 请求，获取结果集
      let res = await fun_PostAction("/department/getDepartmentListInit");
      // 解构res.data
      const { result, data, msg } = res.data;
      // 操作成功
      if (result) {
        // 赋值下拉框
        this.options = data;
      } else {
        // 请求失败，提示错误信息
        this.$message.error(msg);
      }
    },
    /**
     * 表单提交
     * @author 滕威
     */
    fun_SubmitForm() {
      // 校验
      this.$refs.form.$refs.enInform.validate(valid => {
        if (valid) {
          // 打开确定按钮loading状态
          this.loading = true;
          // 发起请求，获取结果集
          fun_PutAction("/department/saveOrUpdate", this.form)
            .then(res => {
              // 解构res.data
              const { result, msg } = res.data;
              // 判断请求是否成功
              if (result) {
                // 请求一览查询接口
                this.$parent.fun_GetList();
                // 关闭弹窗
                this.drawerStatus = false;
                // 保存成功
                this.$message.success(msg);
              } else {
                // 请求失败，提示信息
                this.$message.error(msg);
              }
              // 取消确定按钮loading状态
              this.loading = false;
            })
            .catch(() => {
              // 取消确定按钮loading状态
              this.loading = false;
            });
        } else {
          // 校验不通过，返回false，页面给出前端提示
          return false;
        }
      });
      // 关闭抽屉
    },
    fun_Opened() {},
    /**
     * 抽屉关闭时执行
     * @author 滕威
     */
    fun_DrawerClose() {
      // 清除表单验证和数据
      this.$refs.form.$refs.enInform.resetFields();
      // 关闭时，清除勾选
      this.$parent.$refs.list.$refs.multipleTable.clearSelection();
      // 清除选择项
      this.form.parentId = null;
      // 清楚选中项
      this.$refs.tree.setCurrentKey(null);
      this.parentName = null;
      // 修改type为add
      this.type = "add";
    },
    /**
     * 选中部门时执行
     * @author liqi
     */
    fun_ParentIdSelect(data) {
      // 赋值父级节点
      this.form.parentId = data.id;
      this.parentName = data.departmentName;
    },
    /**
     * 下拉框清除选项
     */
    fun_Clear() {
      // 清除所属部门选中的父级主键
      this.form.parentId = null;
      this.parentName = null;
      // 清除选中项
      this.$refs.tree.setCurrentKey(null);
    }
  }
};
